module.exports = __webpack_public_path__ + "img/5-1.c59bde0f.svg";